import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RedemptionAndPayment } from '../payments-common.js';
import { RedemptionAndPaymentUpdateRTM } from '@gains-com/realtime';

@Injectable({
  providedIn: 'root',
})
export class ActiveRedemptionViewService {
  private readonly _activeRedemption = signal<RedemptionAndPayment | null>(null);

  /** Backward-compat stream shim for existing observable consumers. */
  readonly activeRedemption$ = toObservable(this._activeRedemption);

  /** Readonly signal surface for new consumers. */
  readonly activeRedemption = this._activeRedemption.asReadonly();

  clearActiveRedemptionPayment() {
    this._activeRedemption.set(null);
  }

  setActiveRedemption(redemption: RedemptionAndPayment) {
    this._activeRedemption.set(redemption);
  }

  updateRedemption(update: RedemptionAndPaymentUpdateRTM) {
    const redemptionValue = this._activeRedemption();
    if (redemptionValue && update.redemption_id === redemptionValue?.redemption_id) {
      this._activeRedemption.set({ ...redemptionValue, ...update });
    }
  }
}
